export const iconFontAwesomeCommunicationQuoteLeft = (
	<i className="fa-solid fa-quote-left"></i>
);
